var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import cometList from '../../Fct/plugins/compoundv3/helpers/cometList.json';
import { ROUTER_ADDRESSES } from '../../Fct/plugins/sushiswap/constants';
import { ROUTER_V2_ADDRESSES } from '../../Fct/plugins/uniswap/constants';
import aaveV2MainnetErc20 from '../../Fct/tokens/aaveV2MainnetErc20.json';
import aaveV3ArbitrumErc20 from '../../Fct/tokens/AaveV3_arbitrum.json';
import aaveV3BaseErc20 from '../../Fct/tokens/AaveV3_base.json';
import aaveV3MainnetErc20 from '../../Fct/tokens/AaveV3_mainnet.json';
import aaveV3OptimismErc20 from '../../Fct/tokens/AaveV3_optimism.json';
import cTokens from '../../Fct/tokens/cTokens.json';
import curveGaugeTokens from '../../Fct/tokens/curveGaugeTokens.json';
import curveGaugeTokensArbitrum from '../../Fct/tokens/curveGaugeTokensArbitrum.json';
import curveLPTokens from '../../Fct/tokens/curveLPTokens.json';
import curveLPTokensArbitrum from '../../Fct/tokens/curveLPTokensArbitrum.json';
import ETHAddresses from '../../Fct/tokens/ETH.json';
import radiantV2Arbitrum from '../../Fct/tokens/RadiantV2_rTokens_Arbitrum.json';
import uniswapDefaultERC20Addresses from '../../Fct/tokens/uniswapDefault.json';
import aerodromTokens from '../../Fct/tokens/aerodrome.json';
import yTokensArbitrum from '../../Fct/tokens/yearnTokensArbitrum.json';
import yTokensMainnet from '../../Fct/tokens/yearnTokensMainnet.json';
import yVaultsArbitrum from '../../Fct/tokens/yearnVaultsArbitrum.json';
import yVaultsMainnet from '../../Fct/tokens/yearnVaultsMainnet.json';
import { LENDING_POOL_ADDRESSES, PROTOCOL_DATA_PROVIDER_ADDRESSES } from './AaveV2/constants';
import { celerBridgeMainnetTokens } from './cBridge/constants/tokenListMainnet';
import { getSupportedCurveTokens, supportedGauges as supportedCurveGauges, supportedPools as supportedCurvePools, } from './curve/helpers/supportedContracts';
export var INCHSupportedContracts = [{ address: '0x1111111254fb6c44bac0bed2854e76f90643097d', chainId: 1 }];
export var curveExchange = [{ address: '0x55B916Ce078eA594c10a874ba67eCc3d62e29822', chainId: 1 }];
export var allowanceRequiredProtocols = [
    { value: ROUTER_V2_ADDRESSES, name: 'UNISWAP' },
    { value: LENDING_POOL_ADDRESSES, name: 'AAVE_LENDING_POOL' },
    { value: PROTOCOL_DATA_PROVIDER_ADDRESSES, name: 'AAVE_ PROTOCOL_DATA_PROVIDER' },
    { value: ROUTER_ADDRESSES, name: 'SUSHISWAP' },
    { value: INCHSupportedContracts, name: '1INCH' },
    { value: cometList, name: 'COMPOUND_V3' },
    { value: curveExchange, name: 'CURVE_EXCHANGE' },
];
export var getAllowanceRequiredProtocols = function (_a) {
    var chainId = _a.chainId;
    var protocols = allowanceRequiredProtocols.map(function (protocol) {
        var value = protocol.value.find(function (item) { return item.chainId === Number(chainId); });
        return { value: value === null || value === void 0 ? void 0 : value.address, name: protocol.name };
    });
    if (chainId === '1') {
        return protocols.concat(supportedCurvePools).concat(supportedCurveGauges);
    }
    return protocols;
};
export var tokenTypes = [
    'DEFAULT',
    'AAVE_V2',
    'AAVE_V3',
    'CURVE',
    'CURVE_LP',
    'CURVE_GAUGE',
    'YEARN_VAULTS',
    'RADIANT_V2',
    'COMPOUND',
    'YEARN_TOKENS',
    'CELER_BRIDGE',
    'AERODROME',
];
export var getDefaultTokens = function (_a) {
    var chainId = _a.chainId;
    return uniswapDefaultERC20Addresses
        .filter(function (contract) {
        return contract.chainId === Number(chainId);
    })
        .map(function (contract) { return ({
        value: contract.address,
        name: contract.name,
        decimals: contract.decimals,
        symbol: contract.symbol,
        logoURI: contract.logoURI,
        default: true,
    }); });
};
export var getDefaultTokensPath = function (_a) {
    var chainId = _a.chainId;
    return uniswapDefaultERC20Addresses
        .filter(function (contract) {
        return contract.chainId === Number(chainId);
    })
        .map(function (contract) { return ({
        value: [contract.address],
        name: contract.name,
        decimals: contract.decimals,
        symbol: contract.symbol,
        default: true,
        logoURI: contract.logoURI,
    }); });
};
export var getAerodromTokens = function (_a) {
    var chainId = _a.chainId;
    if (chainId === '8453')
        return aerodromTokens.map(function (token) { return (__assign(__assign({ value: token.address }, token), { type: 'AERODROME' })); });
    return [];
};
export var getAaveTokens = function (_a) {
    var chainId = _a.chainId;
    if (chainId === '1')
        return aaveV2MainnetErc20.map(function (token) { return (__assign(__assign({ value: token.address }, token), { type: 'AAVE_V2' })); });
    return [];
};
export var getCelerBridgeTokens = function (_a) {
    var chainId = _a.chainId;
    if (chainId === '1')
        return celerBridgeMainnetTokens;
    return [];
};
export var getCompoundTokens = function (_a) {
    var chainId = _a.chainId;
    return cTokens
        .filter(function (ct) { return ct.chainId === Number(chainId); })
        .map(function (token) { return (__assign(__assign({ value: token.address }, token), { type: 'COMPOUND' })); });
};
export var getCurveLPTokens = function (_a) {
    var chainId = _a.chainId;
    if (chainId === '1')
        return curveLPTokens.map(function (token) { return (__assign(__assign({ value: token.address }, token), { type: 'CURVE_LP' })); });
    if (chainId === '42161')
        return curveLPTokensArbitrum.map(function (token) { return (__assign(__assign({ value: token.address }, token), { type: 'CURVE_LP' })); });
    return [];
};
export var getCurveGaugeTokens = function (_a) {
    var chainId = _a.chainId;
    if (chainId === '1')
        return curveGaugeTokens.map(function (token) { return (__assign(__assign({ value: token.address }, token), { type: 'CURVE_GAUGE' })); });
    if (chainId === '42161')
        return curveGaugeTokensArbitrum.map(function (token) { return (__assign(__assign({ value: token.address }, token), { type: 'CURVE_GAUGE' })); });
    return [];
};
export var getAaveV3Tokens = function (_a) {
    var chainId = _a.chainId;
    if (chainId == '1')
        return aaveV3MainnetErc20.map(function (token) { return (__assign(__assign({ value: token.address }, token), { type: 'AAVE_V3' })); });
    if (chainId == '42161')
        return aaveV3ArbitrumErc20.map(function (token) { return (__assign(__assign({ value: token.address }, token), { type: 'AAVE_V3' })); });
    if (chainId === '10')
        return aaveV3OptimismErc20.map(function (token) { return (__assign(__assign({ value: token.address }, token), { type: 'AAVE_V3' })); });
    if (chainId === '8453')
        return aaveV3BaseErc20.map(function (token) { return (__assign(__assign({ value: token.address }, token), { type: 'AAVE_V3' })); });
    return [];
};
export var getYearnVaults = function (_a) {
    var chainId = _a.chainId;
    if (chainId == '1')
        return yVaultsMainnet.map(function (token) { return (__assign(__assign({}, token), { type: 'YEARN_VAULTS' })); });
    if (chainId == '42161')
        return yVaultsArbitrum.map(function (token) { return (__assign(__assign({}, token), { type: 'YEARN_VAULTS' })); });
    return [];
};
export var getYearnTokens = function (_a) {
    var chainId = _a.chainId;
    if (chainId == '1')
        return yTokensMainnet.map(function (token) { return (__assign(__assign({}, token), { type: 'YEARN_TOKENS' })); });
    if (chainId == '42161')
        return yTokensArbitrum.map(function (token) { return (__assign(__assign({}, token), { type: 'YEARN_TOKENS' })); });
    return [];
};
export var getRadiantV2Tokens = function (_a) {
    var chainId = _a.chainId;
    if (chainId === '42161')
        return radiantV2Arbitrum.map(function (token) { return (__assign(__assign({ value: token.address }, token), { type: 'RADIANT_V2' })); });
    return [];
};
export var getAllCurrencies = function (_a) {
    var chainId = _a.chainId;
    var eth = ETHAddresses.filter(function (item) { return item.chainId === Number(chainId); }).map(function (contract) { return ({
        value: contract.address,
        name: contract.name,
        decimals: contract.decimals,
        symbol: contract.symbol,
        logoURI: contract.logoURI,
        type: 'DEFAULT',
    }); });
    var tokens = getSupportedTokens({ chainId: chainId });
    return eth.concat(tokens);
};
export var getSupportedTokens = function (_a) {
    var chainId = _a.chainId;
    // If chainId is undefined, return all tokens
    var tokenAddresses = new Set();
    var uniswapDefaults = uniswapDefaultERC20Addresses;
    var tokens = uniswapDefaults
        .map(function (contract) { return (__assign(__assign({}, contract), { type: 'DEFAULT' })); })
        .concat(getAaveTokens({ chainId: chainId }).map(function (token) { return (__assign(__assign({}, token), { chainId: Number(chainId) })); }))
        .concat(getAaveV3Tokens({ chainId: chainId }).map(function (token) { return (__assign(__assign({}, token), { chainId: Number(chainId) })); }))
        .concat(getCompoundTokens({ chainId: chainId }))
        .concat(getCurveLPTokens({ chainId: chainId }))
        .concat(getCurveGaugeTokens({ chainId: chainId }))
        .concat(getAerodromTokens({ chainId: chainId }))
        .filter(function (contract) {
        if (chainId && contract.chainId !== Number(chainId))
            return false;
        return true;
    })
        // .filter((contract) => {
        //   if (tokenAddresses.has(contract.address)) return false
        //   tokenAddresses.add(contract.address)
        //   return true
        // })
        .map(function (contract) { return ({
        value: contract.address,
        address: contract.address,
        name: contract.name,
        decimals: contract.decimals,
        symbol: contract.symbol,
        default: contract.name === 'Kirobo' ? true : contract.type === 'DEFAULT',
        logoURI: contract.logoURI,
        chainId: Number(contract.chainId),
        type: contract.type,
    }); });
    if (chainId) {
        return tokens
            .concat(getSupportedCurveTokens(chainId, tokenAddresses))
            .concat(getYearnVaults({ chainId: chainId }))
            .concat(getYearnTokens({ chainId: chainId }));
    }
    return tokens;
};
export var getSupportedContracts = function (_a) {
    var contracts = _a.contracts, chainId = _a.chainId;
    return contracts
        .filter(function (contract) { return contract.chainId === Number(chainId); })
        .map(function (contract) { return ({
        value: contract.address,
        name: contract.name,
        decimals: contract.decimals,
        chainId: contract.chainId,
    }); });
};
